import {AnimationSpeed, SpringConfig} from '../types';

export const springConfigs: Record<AnimationSpeed, SpringConfig> = {
    fast: {
        tension: 300,
        friction: 30,
        duration: 200
    },
    medium: {
        tension: 200,
        friction: 25,
        duration: 300
    },
    slow: {
        tension: 100,
        friction: 20,
        duration: 500
    }
};

export const getSpringConfig = (speed: AnimationSpeed): SpringConfig => {
    return springConfigs[speed] || springConfigs.medium;
};
